/**
 * 基础菜单
 */
<template>
  <div>
    <div>
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="区域：">
          <!-- <Cascader @setData="setData"></Cascader> -->
          <Cascader ref="Cascader"></Cascader>
          <!-- <label style="color: red;">友情提示：可以选择全市</label> -->
        </el-form-item>
        <el-form-item label="关键词">
          <el-input size="small" v-model="formInline.keyword" placeholder="输入关键词5个字以内"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-popover placement="bottom" width="400" trigger="hover">
          <label style="">使用方法:选择城市-区域(可多选)一输入关键 (越精准越好)搜索一下载xlsx表格</label>
          <el-button type="text" style="color: red;font-size: 12x; margin-top: 10px;" slot="reference">提示</el-button>
        </el-popover>
      </el-form>
    </div>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="city" label="城市" width="200">
      </el-table-column>
      <el-table-column sortable prop="region" label="区域" width="200">
      </el-table-column>
      <el-table-column sortable prop="keyword" label="关键词" width="200">
      </el-table-column>
      <el-table-column sortable prop="queryDate" label="查询日期" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作/状态（文件保留7天）" min-width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.fileName }}</div>
          <el-button size="mini" @click="download(scope.$index, scope.row)">下载</el-button>
          <el-button size="mini" @click="preview(scope.$index, scope.row)">预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog
      :close-on-click-modal="true"
      title="文件预览"
      type="primary"
      :visible.sync="previewDialog"
      width="800px"
      left
    >
      <iframe
        :src="attachmentSrc"
        frameborder="0"
        width="100%"
        height="500px"
      ></iframe>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-on:click="previewDialog = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>

</template>

<script>
import Cascader from '../assembly/Cascader.vue'
import { mainList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      previewDialog: false,
      attachmentSrc:'',
      title: '添加',
      formInline: {
        page: 1,
        limit: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    Cascader
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  mounted() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    // 获取公司列表
    getdata(parameter) {
      let selectData = this.$refs.Cascader.selectData;
      if (selectData.length > 0) {
        Object.assign(parameter, {
          province: selectData[0][0],
          city: selectData[0][1],
          regions: selectData
        })
      }
      if(parameter.keyword==null&&selectData.length>0){
        this.$message.error('搜索时关键词不可以为空！')
        return;
      }
      if(parameter.keyword!=null&&selectData.length==0){
        this.$message.error('搜索时区域不可以为空！')
        return;
      }
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      mainList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'error',
              message: res.message
            })
          } else {
            if (res.message != '请求成功') {
              this.$message({
                type: 'warning',
                message: res.message
              })
            }
            this.listData = res.data.records
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.count
          }
        })
        .catch(err => {
          debugger
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面s
    download: function (index, row) {
      window.open(row.url);
    },
    //显示编辑界面s
    preview: function (index, row) {
      if(this._isMobile()){
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + row.url);
      }else{
        this.attachmentSrc = "https://view.officeapps.live.com/op/view.aspx?src=" + row.url;
        this.previewDialog = true;
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/address.vue